
<a (click)="capturaId(product.id_product, indexSection, product)">
    <div class="body-card">
        <div class="d-flex">
            <div class="image-card" [ngClass]="{'not-animation': this.imgLoadead}">
                <img [src]="product.image_prod" (load)="this.loadImgComplete($event)" style="width: 100px; height: 100px;">
            </div>
        </div>
        <div class="info-card">
            <div class="description-card">
                <div class="name-card"  [textContent]="product.name"></div>
                <div class="detail-card" [textContent]="product.description"></div>
            </div>


            <ng-container *ngIf="product.promotion == 1">

                <ng-container *ngIf="product.cashback != '0.00' && (typeParam.type == 0 || typeParam.type == 3)">
                    <span class="cashback" *ngIf="product.cashbackType == 1">{{ product.cashback.replace('.00', '') }}% Cashback</span>
                    <span class="cashback" *ngIf="product.cashbackType == 2">{{ product.cashback | currency:'BRL' }} Cashback</span>
                </ng-container>

                <div class="values-card">

                    <div class="box-card-promotion">

                        <!--Valores do desconto-->
                        <!-- <span class="value-discount" *ngIf="product.typeDay == 2">
                            R$ -{{(product.discountDay | currency:'BRL')?.replace('R$', '')?.trim()}}
                        </span> -->
                        
                        <!--Valores do desconto-->
                        <!-- <span class="value-discount" *ngIf="product.typeDay == 1">
                            -{{product.discountDay.replace('.00', '')}}%
                        </span> -->

                        <!--Valores do produto-->
                        <div style="display: flex; gap: 8px; align-items: center;">
                            <span class="value-card__Promotion">{{ product.realPrice | currency:'BRL' }}</span>
                            <span>{{ product.price | currency:'BRL' }}</span>
                        </div>

                    </div>
                </div>

            </ng-container>

            <ng-container *ngIf="product.promotion == 0">


                <ng-container *ngIf="product.cashback != '0.00' && (typeParam.type == 0 || typeParam.type == 3)">
                    <span class="cashback" *ngIf="product.cashbackType == 1">{{ product.cashback.replace('.00', '') }}% Cashback</span>
                    <span class="cashback" *ngIf="product.cashbackType == 2">{{ product.cashback | currency:'BRL' }} Cashback</span>
                </ng-container>

                <div class="values-card">
    
                    <ng-container *ngIf="product.minPrice == product.price && product.pizza == 0"> 

                        <!--Valores do produto-->
                        <span style="width: 100%;" class="value-card__value" *ngIf="product.price != 0">
                            {{ product.price | currency:'BRL' }}
                        </span>

                        <!--Caso o produto não tenha preço-->
                        <span style="width: 100%;" class="value-card__value" *ngIf="product.price == 0">
                            <i class="icon-chevron-right" style="color: var(--primary-color);"></i>
                        </span>

                    </ng-container>

                    <ng-container *ngIf="product.minPrice != product.price || product.pizza == 1">
                    
                        <!--Valor do produto com apartir de-->
                        <div style="display: flex; width: 100%; justify-content: flex-end; gap: 10px; align-items: center;">
                            <span class="span_card__value">A partir de</span>
                            <span class="value-card__value">
                            {{ product.minPrice | currency:'BRL' }}
                            </span>
                        </div>

                    </ng-container>

                </div>



            </ng-container>

        </div>
    </div>
</a>